import {
  AdUnlockVariations,
  AppRouteName,
  JournalType,
  Source,
} from '@chegg-wt/core/types/core'
import { action, createAction, createStandardAction } from 'typesafe-actions'
import { createErrorAction } from '@chegg-wt/core/utils/actions'
import { ActionTypes } from './constants'

export const sourceTypeSelected = createAction(
  ActionTypes.CREATE_CITATION_SOURCE_TYPE_SELECTED,
  (action) => (sourceType: string, redirectTo?: AppRouteName) =>
    action({ sourceType, redirectTo })
)

export const sourceQueryEntered = createAction(
  ActionTypes.CREATE_CITATION_QUERY_ENTERED,
  (action) => (query: string) => action({ query })
)

export const sourceSearchResultsPageLoaded = (
  query: string,
  style: string,
  sourceType: string,
  crossrefResultCountEnabled: boolean
) =>
  action(ActionTypes.CREATE_CITATION_SEARCH_RESULTS_PAGE_LOADED, {
    query,
    style,
    sourceType,
    crossrefResultCountEnabled,
  })

export const sourceSearchSucceeded = (sources: Source[]) =>
  action(ActionTypes.CREATE_CITATION_SEARCH_SUCCEEDED, { sources })

export const sourceSearchFailed = createErrorAction(
  ActionTypes.CREATE_CITATION_SEARCH_FAILED
)

const sourceSelectionActionCreator = <T extends string>(actionType: T) =>
  createAction(
    actionType,
    (action) => (selectedSource: Source, searchQuery: string, index?: number) =>
      action({ selectedSource, searchQuery, index })
  )

export const sourceSelected = sourceSelectionActionCreator(
  ActionTypes.CREATE_CITATION_SOURCE_SELECTED
)

export const sourceSelectionCompleted = sourceSelectionActionCreator(
  ActionTypes.SOURCE_SELECTION_COMPLETED
)

export const sourceSelectionAutociteRequestFailed = createErrorAction(
  ActionTypes.SOURCE_SELECTION_AUTOCITE_REQUEST_FAILED
)

export const journalEngineSelected = (
  type: JournalType,
  crossrefResultCountEnabled: boolean
) =>
  action(ActionTypes.CREATE_CITATION_JOURNAL_TAB_SELECTED, {
    type,
    crossrefResultCountEnabled,
  })

export const onNewCitation = createStandardAction(ActionTypes.ON_NEW_CITATION)()

export const setAutociteV0RioOptFlag = (autociteV0RioOptFlag: boolean) =>
  action(ActionTypes.SET_AUTOCITE_V0_RIO_OPT_FLAG, {
    autociteV0RioOptFlag,
  })

export const setAutociteApiVersion = (autociteApiVersion: string) =>
  action(ActionTypes.SET_AUTOCITE_API_VERSION, {
    autociteApiVersion,
  })

export const setAuthModalExpFlag = (authModalExpFlag: boolean) =>
  action(ActionTypes.SET_AUTH_MODAL_EXP_FLAG, {
    authModalExpFlag,
  })

export const oneClickCitation = createAction(
  ActionTypes.ONE_CLICK_CITATION,
  (action) => (source: Source, index: number) => action({ source, index })
)

export const setAdUnlockExpVariation = (adUnlockVariation: AdUnlockVariations) =>
  action(ActionTypes.SET_AD_UNLOCK_VARIANT, {
    adUnlockVariation,
  })
